<template>
  <Loader :loader="loaderActive"/>
  <div class="container-fluid">
    <div class="row">
      <div class="category-head">
        <div class="back-link">
          <a @click="$router.back()">←</a>
        </div>
        <div class="category-title">
          <p>{{ pageTitle }}</p>
        </div>
      </div>
    </div>

    <div class="row d-flex gap-5 ">
      <div class="col-sm-2 card " v-for="topic in topTopicList" :key="topic.category_id">
        <div class="d-flex flex-column justify-content-center align-items-center">
          <div class="star">
            <i class="fas fa-star"
               v-if="! topic.following"
               @click="followUnfollowTopic(topic.topic_id, true)">
            </i>
            <i class="fas fa-star "
               v-if="topic.following"
               @click="followUnfollowTopic(topic.topic_id, false)"
               style="color: #F6961B">
            </i>
          </div>
          <router-link :to="{ path: '/topic-details', query: {
            topic_id: topic.topic_id,
            topic: 'Top Topic',
            category_name: topic.category_name
          }
         }" class="d-flex flex-column justify-content-center align-items-center">
            <img :src="topic.image_url" alt="Card image">
            <p class=" ">{{ topic.name }} </p>
          </router-link>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Loader from "@/views/components/Loader";
import {sendRequest} from "@/http/axios.method";

export default {
  name: "TopicList",
  components: {
    Loader,
  },
  data() {
    return {
      loaderActive: false,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      topicType: this.$route.query.type,
      pageTitle: this.$route.query.page_title,
      topicList: [],
    }
  },
  created() {
    this.getTopicList();
  },
  methods: {
    getTopicList() {
      this.loaderActive = true;
      sendRequest('get', 'v2.0/top-topics', {}, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.topicList = response.data.topics;
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    followUnfollowTopic(topic_id, topic_follow) {
      this.loaderActive = true;
      let data = {
        topic_id: topic_id,
        follow: topic_follow
      }
      sendRequest('post', 'v2.0/follow-unfollow-topic', data, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.topicList = this.topicList.map(topic => {
                if (topic.topic_id === topic_id) {
                  return {...topic, following: topic_follow};
                }
                return topic;
              });
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
  },
  computed: {
    topTopicList() {
      return this.topicList;
    }
  }
}
</script>

<style scoped>

</style>
